import { z } from "zod";
/*
 * Twin asking the person a structured question mid-session. The agent calls
 * the `twin_ask_user` tool with up to four questions and ends its turn; the
 * session composer shows them as a form, and the answers arrive as the next
 * message. The tool call's arguments are the questions, so the client reads
 * them straight from the run's tool events.
 */
export const TWIN_ASK_USER_TOOL_NAME = "twin_ask_user";
export const twinAskUserQuestionSchema = z.object({
    /** Stable within the call, e.g. "period". */
    id: z.string().trim().min(1).max(40),
    /** The question as the person reads it. */
    prompt: z.string().trim().min(3).max(300),
    /** Choices to pick from; omit for a free-text question. */
    options: z.array(z.string().trim().min(1).max(120)).max(8).optional(),
    /** Whether more than one option may be chosen. */
    multiSelect: z.boolean().optional(),
    /** Whether the person may also (or instead) type an answer. */
    allowText: z.boolean().optional(),
}).strict();
export const twinAskUserArgsSchema = z.object({
    questions: z.array(twinAskUserQuestionSchema).min(1).max(4),
}).strict();
/**
 * The follow-up message that carries the answers: plain text the agent reads
 * like any other message, one line per question, skipped questions included.
 */
export function formatTwinAskUserAnswers(questions, answers) {
    const byId = new Map(answers.map((answer) => [answer.id, answer]));
    const lines = questions.map((question) => {
        const answer = byId.get(question.id);
        const parts = [
            ...(answer?.selected.length ? [answer.selected.join(", ")] : []),
            ...(answer?.text?.trim() ? [answer.text.trim()] : []),
        ];
        return `- ${question.prompt} ${parts.length ? parts.join(" — ") : "(skipped)"}`;
    });
    return ["My answers:", ...lines].join("\n");
}
